export const environment = {
  production: false,
  baseUrl: 'https://kelltoncommerce-dev-api-postgres.kellton.net/api',
  imageUrl: 'https://kelltoncommerce-dev-api-postgres.kellton.net/api/media/image-resize',
  productUrl: 'https://kelltoncommerce-dev-api-postgres.kellton.net/api',
  pluginUrl: 'https://kelltoncommerce-dev-api-postgres.kellton.net/api',
  blogUrl: 'https://kelltoncommerce-dev-api-postgres.kellton.net/api',
  labelUrl : 'https://kelltoncommerce-dev-api-postgres.kellton.net/api'
};